import { ReduxService } from 'dashboard-services/services';

import { basicDataStorageCreatorActions as basicActions, resultsDataStorageCreatorActions as resultsActions } from 'actions/modules/dataStorage/creator';

export const resultsInitialState = {
  columns: [],
  values: [],
  finalCorrections: "false",

  chartColumns: new Map(),
  chartValues: [],
  statistics: {},
  statisticsSymbols: {}
}

export default (state = resultsInitialState, action) => {
  switch (action.type) {
    case resultsActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicActions.CLEAR:
      return resultsInitialState;
    case resultsActions.CLEAR_CHARTS:
      return ReduxService.updateObject(state, { chartColumns: resultsInitialState.chartColumns, chartValues: resultsInitialState.chartValues })
    default:
      return state; 
  }
}